export class ComboParticipanteReuniao {
	
	id:number;                 
	nome:string;
	origem:string;
}